module.exports = __webpack_public_path__ + "static/media/step5.afd34abb.png";